import React, { Component } from 'react';
import Switch from 'react-switch';
import SettingsNavBar from './SettingsNavBar';
import SideBar from '../../components/SideBar';

class Notifications extends Component {
  constructor() {
    super();
    this.state = {
    };
  }

  handleChange = (item) => {
    this.setState((prevState) => {
      return { [item]: !prevState[item] };
    });
  }

  handleSubmit = (event) => {
    event.preventDefault();
  }

  render() {
    return (
      <div className="flex-container">
        <SideBar defaultPage="account" />
        <SettingsNavBar defaultPage="notifications" />
        <div className="notification-container">
          <h2 className="color account-header">Notifications</h2>
          <div className="box notification-form-container">
            <div className="notification-form-row">
              <div className="notification-text-container">
                <h3 className="color">New surveys, updates</h3>
                <p className="color">Notify me about new surveys </p>
              </div>
              <Switch
                onChange={() => this.handleChange('newSurveys')}
                checked={this.state.newSurveys}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={43}
              />
            </div>
            <div className="notification-form-row">
              <div className="notification-text-container">
                <h3 className="color">New resources</h3>
                <p className="color">Notify me about new resources on my toolkit</p>
              </div>
              <Switch
                onChange={() => this.handleChange('newResources')}
                checked={this.state.newResources}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={43}
              />
            </div>
            <div className="notification-form-row">
              <div className="notification-text-container">
                <h3 className="color">Ongoing survey</h3>
                <p className="color">Notify me about my unfinished surveys</p>
              </div>
              <Switch
                onChange={() => this.handleChange('unfinishedSurveys')}
                checked={this.state.unfinishedSurveys}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={43}
              />
            </div>
            <div className="notification-form-row">
              <div className="notification-text-container">
                <h3 className="color">Recommended survey</h3>
                <p className="color">Notify me of surveys I might take based on my past surveys</p>
              </div>
              <Switch
                onChange={() => this.handleChange('recommendedSurveys')}
                checked={this.state.recommendedSurveys}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={43}
              />
            </div>
            <div className="notification-form-row">
              <div className="notification-text-container">
                <h3 className="color">Email</h3>
                <p className="color">Recommend me surveys through email</p>
              </div>
              <Switch
                onChange={() => this.handleChange('email')}
                checked={this.state.email}
                checkedIcon={false}
                uncheckedIcon={false}
                height={20}
                width={43}
              />
            </div>
            <br />
            <button className="save-button" type="button">Save</button>
          </div>
        </div>
      </div>
    );
  }
}

export default Notifications;
